import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import { translations } from "src/helper/translations"
import { imgUrl } from "src/mixins"

export default function OurCommitmentCover({ data, locale }) {
  return (
    <section className="sc-our-commitment-cover">
      <Cover
        scrollHint
        imgHeight="h-vh-100"
        contentMaxWidth="mw-md-750px"
        title={data && data[`title_${locale}`]}
        text={data && data[`description_${locale}`]}
        img={imgUrl(data?.banner_image_mobile)}
        imgMd={imgUrl(data?.banner_image_desktop)}
        breadcrumb={
          <Breadcrumb
            path={`/${translations[`our_commitment_${locale}`]}`}
            theme="dark"
          />
        }
        imgOverlay="70"
      />
    </section>
  )
}
